/**************************************************
 * Nombre:       Bit_Nova
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import b from "../../../Recursos/b.svg";
import n from "../../../Recursos/n.svg";
import {useResponsive} from "../../../Modulo_Responsive/Hooks/useResponsive";

const Bit_Nova = () => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
        >

            <Grid container size={{xs: 6, sm: 3, md: 3}} sx={{justifyContent: 'center', mt: 7}}>
                <img src={b} width={sCell ? 50 : 70} height={'auto'}/>
            </Grid>

            <Grid container size={{xs: 6, sm: 3, md: 3}} sx={{justifyContent: 'flex-start'}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}>

                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                          sx={{justifyContent: 'flex-start', mt: 6}}>
                        <Typography sx={{fontSize: sCell ? 24 : 36, fontWeight: 600, textAlign: 'flex-start'}}>
                            Bit
                        </Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                          sx={{justifyContent: 'flex-start', mt: 0}}>
                        <Typography sx={{fontSize: sCell ? 12 : 14, fontWeight: 400, textAlign: 'flex-start'}}>
                            Representa lo digital y la tecnología blockchain como base para transformar la
                            economía.
                        </Typography>
                    </Grid>

                </Grid>
            </Grid>

            <Grid container size={{xs: 6, sm: 3, md: 3}} sx={{justifyContent: 'center', mt: 7}}>
                <img src={n} width={sCell ? 70 : 90} height={'auto'}/>
            </Grid>

            <Grid container size={{xs: 6, sm: 3, md: 3}} sx={{justifyContent: 'flex-start'}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}>

                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                          sx={{justifyContent: 'flex-start', mt: 6}}>
                        <Typography sx={{fontSize: sCell ? 24 : 36, fontWeight: 600, textAlign: 'flex-start'}}>
                            Nova
                        </Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                          sx={{justifyContent: 'flex-start', mt: 0}}>
                        <Typography sx={{fontSize: sCell ? 12 : 14, fontWeight: 400, textAlign: 'flex-start'}}>
                            Simboliza expansión, energía y crecimiento acelerado del patrimonio a través de
                            activos digitales y físicos.
                        </Typography>
                    </Grid>

                </Grid>
            </Grid>

        </Grid>
    )

}
export default Bit_Nova